module.exports = "<div class=\"ticket-item__header\">\n\t<div class=\"category\">\n\t\tKategorie\n\t</div>\n\t<div class=\"pricelevel\">\n\t\tPreisstufe\n\t</div>\n\t<div class=\"price\">\n\t\tEinzelpreis\n\t</div>\n\t<div class=\"seat\" *ngIf=\"visualTickets || visualBulkTickets\">\n\t\tBlock/Reihe/Sitz\n\t</div>\n\t<div class=\"amount\" *ngIf=\"(!visualTickets && !visualBulkTickets) || visualBulkTickets\">\n\t\tAnzahl\n\t</div>\n\t<div class=\"price-sum\">\n\t\tPreis\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shopping-cart/shopping-cart-event-list/not-editable/item-header.presentation.html
// module id = 5j7+
// module chunks = 12